import * as React from "react";

function Linkedin(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 25 24" fill="none" {...props}>
      <path
        d="M1.07 23.09H6.16V7.764H1.07V23.09zM3.655.367C1.905.367.768 1.514.768 3.024c0 1.47 1.107 2.646 2.817 2.646h.03c1.782 0 2.889-1.177 2.889-2.646C6.474 1.514 5.397.367 3.656.367zm20.89 13.938V23.1h-5.101v-8.202c0-2.063-.735-3.461-2.586-3.461-1.41 0-2.245.946-2.617 1.861-.13.332-.17.785-.17 1.238V23.1H8.988s.07-13.897 0-15.336h5.102v2.173l-.03.05h.03v-.05c.675-1.046 1.882-2.536 4.59-2.536 3.35 0 5.866 2.194 5.866 6.904z"
        fill="#000"
      />
    </svg>
  );
}

const MemoLinkedin = React.memo(Linkedin);
export default MemoLinkedin;
